"use client";

import { useEffect, useRef } from "react";
import { useRouter, useSearchParams } from "next/navigation";

/**
 * Isolated `useSearchParams` usage so listing pages can SSR their rows
 * instead of bailing out to a Suspense skeleton.
 */
export function PublicListingUrlSync({
  href,
  persist,
  isCurrentSearch,
}: {
  href: string;
  persist?: (href: string) => void;
  isCurrentSearch: (searchParams: URLSearchParams) => boolean;
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const isFirstSyncRef = useRef(true);

  useEffect(() => {
    persist?.(href);

    if (isFirstSyncRef.current) {
      isFirstSyncRef.current = false;
      return;
    }

    if (isCurrentSearch(searchParams)) return;
    router.replace(href, { scroll: false });
  }, [href, persist, isCurrentSearch, searchParams, router]);

  return null;
}
